<template>
  <el-dialog
    title="Mailchimp Accounts"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    @open="open"
  >
    <loader v-if="$apollo.loading || loadingContacts" msg="Loading Accounts" />

    <div v-for="account in contactAccounts" :key="account.id" v-else>
      <div class="ibox-title">
        <h5>{{parseProviderName(accounst.provider)}}</h5>
      </div>
      <contact-lists-select
        :id="account.id"
        :provider="account.provider"
        @selectedListsChange="handleSelectedListsChange"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        v-if="!$apollo.loading && !loadingContacts"
        @click="handleImportClick"
      >Import Contacts</el-button>
    </div>
  </el-dialog>
</template>

<script>
import gql from 'graphql-tag';
import contactAccountsListProviderQuery from '@/graphql/contacts/contactAccountsListProvider.gql';
import Loader from '@/components/common/Loader';
import { parseProviderName } from '@/helpers/contact';
import ContactListsSelect from './ContactListsSelect';

export default {
  name: 'MailChimpDialog',
  components: {
    ContactListsSelect,
    Loader,
  },
  props: {
    contacts: {
      type: Array,
      default: () => [],
    },
    isVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    loadingContacts: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default:
        'No emails were provided in this survey, make sure the survey asks for an email address.',
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.isVisible;
      },
      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
    operations() {
      let listOperations = {};

      Object.keys(this.selectedLists).forEach(key => {
        let operations = [];
        const listIds = this.selectedLists[key];

        listIds.forEach(listId => {
          operations = this.contacts.map(contact => ({
            method: 'POST',
            path: `/lists/${listId}/members/`,
            operation_id: `add-${contact.email_address}-${listId}`,
            body: contact,
          }));

          listOperations = {
            ...listOperations,
            [key]: [...operations],
          };
        });
      });
      return listOperations;
    },
  },
  data: () => ({
    contactAccounts: [],
    selectedLists: {},
  }),
  apollo: {
    $client: 'apiv2',
    contactAccounts: {
      query: contactAccountsListProviderQuery,
      prefetch: true,
      variables() {
        return {
          provider: 'mail_chimp',
        };
      },
    },
  },
  methods: {
    parseProviderName,
    handleSelectedListsChange(id, lists) {
      this.selectedLists[id] = lists;
    },
    buildMutations() {
      let mutations = [];
      Object.keys(this.operations).forEach(key => {
        const operationList = this.operations[key];
        mutations = [
          ...mutations,
          {
            client: 'apiv2',
            mutation: gql`
              mutation($id: String!, $operationsData: Json!) {
                mailChimpImport(id: $id, operationsData: $operationsData) {
                  id
                  type
                  errorCount
                  contactCount
                }
              }
            `,
            variables: { id: key, operationsData: operationList },
          },
        ];
      });
      return mutations;
    },
    async handleImportClick() {
      if (Object.keys(this.operations).length === 0) {
        this.$notify({
          title: 'No emails provided!',
          message: this.errorMessage,
          type: 'warning',
        });
        this.dialogVisible = false;
        return;
      }
      const mutations = this.buildMutations();
      mutations.forEach(async mutation => {
        await this.$apollo.mutate(mutation);
      });
      this.$notify({
        title: 'Contacts imported!',
        message: 'Please allow up to 24 hours for contacts to show in mail chimp.',
        type: 'success',
      });
      this.dialogVisible = false;
    },
    open() {
      this.$emit('open');
    },
  },
};
</script>



// WEBPACK FOOTER //
// MailChimpDialog.vue?ef3fa4de